/* @flow */
import AuthActions from 'auth/AuthActions';
import BirthdateModal from './BirthdateModal';
import CurrentUser from 'auth/CurrentUser';
import UserActions from 'user/UserActions';
import { Container } from 'flux/utils';
import invariant from 'invariant';
import * as React from 'react';
import User from 'entities/User';
import waitForPromises from 'lib/waitForPromises';

export function GetBirthdateForChat({ receiver }: { receiver: User }) {
  // XXX ReportChatView class belongs to another component
  return (
    <div className="ReportChatView">
      <div className="ReportChatView-wrap">
        <BirthdateModal user={receiver} />
      </div>
    </div>
  );
}

export class GetBirthdateForChatContainer extends React.Component<{}, *> {
  static routePrefetch = [
    // $FlowFixMe missing annotation
    params => {
      AuthActions.jwtTokenSignIn(params.token);
      return UserActions.loadCurrentUser(params.token);
    },
  ];

  static getStores() {
    return [CurrentUser];
  }

  static calculateState() {
    const receiver = CurrentUser.getUser();
    return {
      receiver,
    };
  }

  render() {
    invariant(this.state, 'state not available');
    return <GetBirthdateForChat receiver={this.state.receiver} />;
  }
}

const container = Container.create(GetBirthdateForChatContainer);

export default waitForPromises(container);
